/* eslint-disable no-shadow,no-unused-vars */
import messages from 'components/AdManager/messages';
import { intl } from 'components/LocaleProvider';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import getSiteDomain from 'utils/getSiteDomain';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const objToQuery = (obj) => {
  const isObject = (obj) => obj && typeof obj === 'object';

  return Object.entries(obj)
    .map(([key, val]) => {
      if (isObject(val)) {
        return `${key}=${encodeURIComponent(JSON.stringify(val))}`;
      }
      return `${key}=${encodeURIComponent(val)}`;
    })
    .join('&');
};

const getRtcConfig = ({ slotId, targets }) => {
  const domain = getSiteDomain(publicRuntimeConfig.wp_site_url);

  const params = {
    // debug: 1,
    tag_id: `mcontigo/${domain}`,
    tenant: domain,
    slot: slotId,
    curl: 'CANONICAL_URL',
    gdpr_consent: 'CONSENT_STRING'
  };

  if (targets) {
    params.targeting = targets;
  }

  const rtcConfig = {
    urls: [`${publicRuntimeConfig.PREBID_SERVER_URL}/openrtb2/amp?${objToQuery(params)}`],
    timeoutMillis: 5000
  };

  return JSON.stringify(rtcConfig);
};

const AmpAdSlot = ({ unit, containerId, ampSizes, targets, className }) => {
  const slotId = 'mc-amp-1';
  return (
    <Fragment>
      <amp-layout id={containerId} className={className}>
        <amp-ad
          data-block-on-consent="_till_responded"
          width={ampSizes.width}
          height={ampSizes.height}
          type="doubleclick"
          data-slot={unit}
          layout="fixed"
          data-ad-container-id={containerId}
          data-multi-size={ampSizes.mobile}
          // Disable multi-size validation, more details on:
          // https://github.com/ampproject/amphtml/blob/master/extensions/amp-ad-network-doubleclick-impl/multi-size.md
          data-multi-size-validation="false"
          // Request non-personalized ads, because we didn't request User Consent.
          // See more details on: https://github.com/ampproject/amphtml/blob/master/extensions/amp-ad-network-doubleclick-impl/amp-consent.md
          data-npa-on-unknown-consent="true"
          data-force-safeframe="true"
          data-loading-strategy="3"
          rtc-config={getRtcConfig({
            slotId,
            targets,
          })}
        >
        </amp-ad>
      </amp-layout>
      <style jsx global>
        {`
          .ad-space::before {
            content: '${intl.formatMessage(messages.advertising)}';
            text-align: center;
            display: block;
            white-space: nowrap;
            font-size: 10px;
            line-height: 15px;
            letter-spacing: 1px;
            color: #6d6d6e;
            text-transform: uppercase;
            margin: 0 auto;
          }
        `}
      </style>
    </Fragment>
  );
};

AmpAdSlot.propTypes = {
  unit: PropTypes.string,
  containerId: PropTypes.string,
  className: PropTypes.string,
  ampSizes: PropTypes.object,
  targets: PropTypes.object,
};

export default AmpAdSlot;
